import { render, staticRenderFns } from "./ContentLayout.vue?vue&type=template&id=5299a9d2&scoped=true&"
var script = {}
import style0 from "./ContentLayout.vue?vue&type=style&index=0&id=5299a9d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5299a9d2",
  null
  
)

export default component.exports